/**
 * © 2024 Little Shilling, Inc.
 * Shon Little
 * Created: 2024-02-20
 */

// Add third-party dependencies.
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Create the publicSlice.
export const publicSlice = createApi({
  reducerPath: 'publicApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API }),
  // Add endpoints here.
  tagTypes: ['pointsOfInterest', 'dynamicComponents', 'images', 'camps', 'pdfs', 'recitalVideos', 'chatBot'],
  endpoints: (builder) => ({
    // Point of Interest.
    getPointOfInterest: builder.query({
      query: () => 'public/points-of-interest/',
      providesTags: ['pointsOfInterest'],
    }),
    // Dynamic Components.
    getDynamicComponentsForPage: builder.query({
      query: (page) => `public/dynamic-components/?page=${page}`,
      providesTags: ['dynamicComponents'],
    }),
    // Images.
    getImages: builder.query({
      query: (imageName) => `public/images/?name=${imageName}`,
      providesTags: ['images'],
    }),
    // Camps.
    getCamps: builder.query({
      query: () => 'public/camps/',
      providesTags: ['camps'],
    }),
    // Camps Contact.
    createCampsContact: builder.mutation({
      query: (campsContact) => ({
        url: 'public/camps-contact/',
        method: 'POST',
        body: campsContact,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }),
    // PDFs.
    getPdf: builder.query({
      query: (pdfName) => `public/pdfs/?name=${pdfName}`,
      providesTags: ['pdfs'],
    }),
    // Recital Videos.
    getRecitalVideos: builder.query({
      query: (year) => `public/recital-videos/?year=${year}`,
      providesTags: ['recitalVideos'],
    }),
    // Chat Bot.
    chatBot: builder.mutation({
      query: (body) => ({ url: 'public/chat/', method: 'POST', body }),
      headers: {
        'Content-Type': 'application/json',
      },
      invalidatesTags: ['chatBot'],
    }),
    // Darby Talent Show.
    createDarbyTalentShowSubmission: builder.mutation({
      query: (formData) => ({
        url: 'public/darby-talent-show/',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

// Export the auto-generated hooks.
export const {
  useGetPointOfInterestQuery,
  useGetDynamicComponentsForPageQuery,
  useGetImagesQuery,
  useGetCampsQuery,
  useGetPdfQuery,
  useCreateCampsContactMutation,
  useGetRecitalVideosQuery,
  useChatBotMutation,
  useCreateDarbyTalentShowSubmissionMutation,
} = publicSlice;
